import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { LoadDataFacade, SetInitialStateFacade } from '../../../../../common/models';
import {
  UserItemApprove,
  UserItemCreate,
  UserItemDelete,
  UserItemInitialState,
  UserItemLoad,
  UserItemUpdate,
  UserItemRolesLoad,
  UserItemResetPassword,
  UserEmailSearch,
  ActiveDirectoryEmailSearch,
} from './user-item.actions';
import { UserItemState, UserItemStateModel } from './user-item.state';
import { UserUpdateModel, UserModel, UserRolesModel, UserEmailSearchModel } from '../models';
import { MatDialogRef } from '@angular/material/dialog';
import { UserOwnerType } from '../constants';
import { Role } from '../../../../../common/constants';
import { ConfirmationDialogAfterClosedModel } from '../../../../../ui-kit';

@Injectable({ providedIn: 'root' })
export class UserItemFacade implements LoadDataFacade, SetInitialStateFacade {
  state$: Observable<UserItemStateModel> = this.store.select(UserItemState.getState);
  userData$: Observable<UserModel> = this.store.select(UserItemState.getUserData);
  userId$: Observable<number> = this.store.select(UserItemState.getUserId);
  userName$: Observable<string> = this.store.select(UserItemState.getUserName);
  emailSearchResult$: Observable<UserEmailSearchModel> = this.store.select(UserItemState.getEmailSearchResult);
  emailSearchInActiveDirectoryResult$: Observable<UserEmailSearchModel> = this.store.select(
    UserItemState.getEmailSearchInActiveDirectoryResult,
  );
  loaded$: Observable<boolean> = this.store.select(UserItemState.getLoaded);
  roleList$: Observable<UserRolesModel> = this.store.select(UserItemState.getRoleList);

  constructor(private store: Store) {}

  loadAll(userId: string): void {
    this.store.dispatch(new UserItemLoad(userId));
  }

  loadAllRoleList(target: UserOwnerType): void {
    this.store.dispatch(new UserItemRolesLoad(target));
  }

  emailSearch(email: string): void {
    this.store.dispatch(new UserEmailSearch(email));
  }

  activeDirectoryEmailSearch(email: string): void {
    this.store.dispatch(new ActiveDirectoryEmailSearch(email));
  }

  approveUser(userId: string, role: Role[]): void {
    this.store.dispatch(new UserItemApprove({ userId, role }));
  }

  createUser(data: UserUpdateModel): void {
    this.store.dispatch(new UserItemCreate(data));
  }

  resetUserPassword(userId: string, dialog: MatDialogRef<ConfirmationDialogAfterClosedModel>): void {
    this.store.dispatch(new UserItemResetPassword({ userId, dialog }));
  }

  updateUser(data: UserUpdateModel): void {
    this.store.dispatch(new UserItemUpdate(data));
  }

  deleteUsers(userIds: number[], dialog: MatDialogRef<ConfirmationDialogAfterClosedModel>): void {
    this.store.dispatch(new UserItemDelete({ dialog, userIds }));
  }

  setInitialState(): void {
    this.store.dispatch(new UserItemInitialState());
  }
}
